// extracted by mini-css-extract-plugin
export var externalLink = "_aq-0";
export var internalLinkLabel = "_aq-1";